import React, { useState } from 'react';
import CompanyItem from './CompanyItem';

const CompanyList = ({ companies, onEdit, onDelete }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [locationFilter, setLocationFilter] = useState('');

  // Get unique locations for filter dropdown
  const locations = [...new Set(companies.map(company =>
    company.location || company.address).filter(Boolean))];

  // Filter companies based on search term and location filter
  const filteredCompanies = companies.filter(company => {
    const matchesSearch =
      (company.name && company.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (company.industry && company.industry.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (company.email && company.email.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesLocation = locationFilter === '' ||
      (company.location && company.location === locationFilter) ||
      (company.address && company.address === locationFilter);

    return matchesSearch && matchesLocation;
  });

  return (
    <div style={styles.container}>
      <div style={styles.filterSection}>
        <div style={styles.filterHeader}>
          <div style={styles.filterTitle}>
            <span style={styles.filterIcon}>🔍</span>
            <span>Search & Filter</span>
          </div>
        </div>

        <div style={styles.filters}>
          <div style={styles.searchBox}>
            <input
              type="text"
              placeholder="Search companies by name or industry"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm('')}
                style={styles.clearButton}
                title="Clear search"
              >
                ✕
              </button>
            )}
          </div>

          <div style={styles.filterBox}>
            <select
              value={locationFilter}
              onChange={(e) => setLocationFilter(e.target.value)}
              style={styles.filterSelect}
            >
              <option value="">All Locations</option>
              {locations.map((location, index) => (
                <option key={index} value={location}>{location}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div style={styles.listHeader}>
        <div style={styles.headerName}>Company Name</div>
        <div style={styles.headerEmail}>Email</div>
        <div style={styles.headerPhone}>Phone</div>
        <div style={styles.headerIndustry}>Industry</div>
        <div style={styles.headerLocation}>Location</div>
        <div style={styles.headerActions}>Actions</div>
      </div>

      <div style={styles.list}>
        {filteredCompanies.length > 0 ? (
          filteredCompanies.map(company => (
            <CompanyItem
              key={company.id}
              company={company}
              onEdit={() => onEdit(company)}
              onDelete={() => onDelete(company.id)}
            />
          ))
        ) : (
          <div style={styles.noResults}>
            <div style={styles.noResultsIcon}>🔍</div>
            <div style={styles.noResultsText}>No companies found matching your criteria.</div>
            <button
              onClick={() => {
                setSearchTerm('');
                setLocationFilter('');
              }}
              style={styles.resetButton}
            >
              Reset Filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '1.5rem',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  filterSection: {
    backgroundColor: 'white',
    borderRadius: '8px 8px 0 0',
    marginBottom: '1rem',
  },
  filterHeader: {
    padding: '1rem',
    borderBottom: '1px solid var(--border-color)',
  },
  filterTitle: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    color: 'var(--text-color)',
  },
  filterIcon: {
    marginRight: '0.5rem',
    fontSize: '1.1rem',
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '1rem',
    padding: '1rem',
  },
  searchBox: {
    position: 'relative',
    width: '100%',
  },
  searchInput: {
    width: '100%',
    padding: '0.75rem',
    paddingRight: '2.5rem',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    fontSize: '1rem',
  },
  clearButton: {
    position: 'absolute',
    right: '0.75rem',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    fontSize: '1rem',
    color: 'var(--text-light)',
    cursor: 'pointer',
  },
  filterBox: {
    width: '100%',
  },
  filterSelect: {
    width: '100%',
    padding: '0.75rem',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    fontSize: '1rem',
    backgroundColor: 'var(--background-color)',
    height: '46px',
  },
  listHeader: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 1fr 1fr 1fr 1fr',
    gap: '1rem',
    padding: '0.75rem 1rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px',
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  headerName: {},
  headerEmail: {},
  headerPhone: {},
  headerIndustry: {},
  headerLocation: {},
  headerActions: {
    textAlign: 'center',
  },
  list: {
    marginTop: '0.5rem',
  },
  noResults: {
    padding: '3rem 1rem',
    textAlign: 'center',
    color: 'var(--text-light)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noResultsIcon: {
    fontSize: '3rem',
    marginBottom: '1rem',
    opacity: '0.5',
  },
  noResultsText: {
    marginBottom: '1rem',
  },
  resetButton: {
    padding: '0.5rem 1rem',
    backgroundColor: 'var(--primary-color)',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: '500',
  },
};

export default CompanyList;
